<div class="contents-area" (dragstart)="onDragstartBody($event)">
	<div [ngSwitch]="model.isDisplayTitle">
		<h2 *ngSwitchCase="'1'">付替対象企画回</h2>
		<h2 *ngSwitchCase="'2'">選定対象企画回</h2>
		<div class="element-column">
			<div class="column-list">
				<label class="list-input-title">企画回</label>
				<div class="list-input-content"><input type="text" value="{{model.queryParams.catalogIdName}}" readonly></div>
			</div>
		</div>
	</div>

	<div style="width: 1623px">
		<h1>付替対象商品一覧</h1>
		<div class="action-area">
			<app-pager [prevDisabled]="!model.btnBackEnabled" [nextDisabled]="!model.btnNextEnabled"
				[totalNum]="model.totalNum" [startNum]="model.startDispNum" [endNum]="model.endDispNum"
				(prevHandler)="eventBackHandler()" (nextHandler)="eventNextHandler()">
			</app-pager>
		</div>
		<wj-flex-grid #dtg_FeatureGoods [itemsSource]="model.featureGoodsEdit" [selectionMode]="'Row'"
			[allowSorting]="false" [allowDragging]="'Rows'" [headersVisibility]="'Column'">
			<wj-flex-grid-filter #flr_FeatureGoods></wj-flex-grid-filter>
			<wj-flex-grid-column [minWidth]="5" [width]="250" [header]="'特集'" [binding]="'FeatureCode'"
				[isReadOnly]="true">
				<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
					<select *ngIf="cell.item.ReplacementStatus !== '2'" class="text-label-required select-feature-code"
						[(ngModel)]="cell.item.FeatureCode" [tabindex]="-1" (change)="modify(cell.item)">
						<option *ngFor="let option of model.featureList" [ngValue]="option.FeatureCode">
							{{ option.FeatureCode + ":" + option.FeatureName}}
						</option>
					</select>
					<label *ngIf="cell.item.ReplacementStatus === '2'">
						{{ getFeatureName(cell.item.FeatureCode) }}
					</label>
				</ng-template>
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="250" [header]="'バイヤー向け連絡事項'" [binding]="'BuyerNotice'" [isReadOnly]="true">
				<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
					<app-text-input *ngIf="cell.item.ReplacementStatus !== '2'" [maxChars]="256" [restrict]="'[ -￮]'"
						id="txti_BuyerNotice" #txti_BuyerNotice [subid]="'txti_BuyerNotice'" [tabindex]="0"
						(change)="modify(cell.item)" [(ngModel)]="cell.item.BuyerNotice" [displayCountField]="false" [fullOnly]="true">
					</app-text-input>
					<label *ngIf="cell.item.ReplacementStatus === '2'">
						{{ cell.item.BuyerNotice }}
					</label>
				</ng-template>
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'取引先コード（ソート用）'" [binding]="'SupplierCode'"
				[visible]="false"></wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'取引先名'" [binding]="'SupplierName'" [isReadOnly]="true">
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'Pコード'" [binding]="'PCode'" [isReadOnly]="true">
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="120" [header]="'アイテムコード'" [binding]="'ItemCode'" [isReadOnly]="true">
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'JANコード'" [binding]="'JanCode'" [isReadOnly]="true">
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="200" [header]="'商品案内用商品名'" [binding]="'GuideGoodsName'" [isReadOnly]="true">
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'商品案内容規格名'" [binding]="'GuideStandardName'" [isReadOnly]="true">
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'メーカー名'" [binding]="'MakerName'" [isReadOnly]="true">
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="110" [header]="'価格パターン'" [binding]="'PricePattern'" [isReadOnly]="true">
				<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
					<span *ngIf="cell.item.PricePattern === '0'">通常価</span>
					<span *ngIf="cell.item.PricePattern === '1'">特1</span>
					<span *ngIf="cell.item.PricePattern === '2'">特2</span>
					<span *ngIf="cell.item.PricePattern === '3'">特3</span>
				</ng-template>
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'供給価格（通常）'" [binding]="'SupplyPriceStandard'" [isReadOnly]="true" [align]="'right'">
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="120" [header]="'今回供給価格'" [binding]="'SupplyPrice'" [isReadOnly]="true" [align]="'right'">
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="150" [header]="'仕入価格（通常）'" [binding]="'CostPriceStandard'" [isReadOnly]="true" [align]="'right'">
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="120" [header]="'今回仕入価格'" [binding]="'CostPrice'" [isReadOnly]="true" [align]="'right'">
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="100" [header]="'在庫数'" [binding]="'StockNum'" [isReadOnly]="true" [align]="'right'">
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="180" [header]="'発注単位'" [binding]="'OrderUnitType'" [isReadOnly]="true">
				<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
					{{ getOrderUnitTypeLabel(cell.item.OrderUnitType) }}
				</ng-template>
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="90" [header]="'新規区分'" [binding]="'NewUnitType'" [isReadOnly]="true">
				<ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
					{{ cell.item.NewUnitType === '0' ? '新規' : '既存' }}
				</ng-template>
			</wj-flex-grid-column>
			<wj-flex-grid-column [minWidth]="5" [width]="300" [header]="'備考'" [binding]="'Remarks'" [isReadOnly]="true">
			</wj-flex-grid-column>
		</wj-flex-grid>
	</div>
</div>

<footer class="footer-buttons">
	<button class="btn-primary" id="btn_Entry" #btn_Entry forcedEnabledMode="none" [tabindex]="0" (click)="update()"
		[disabled]="model.isButtonsDisabled">登録</button>
</footer>